// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1843":"aa43eb9a","2978":"aa43eb9a","8268":"aa43eb9a"}[chunkId] + ".chunk.css";
};